var $ = jQuery.noConflict(); // This releases the `$` symbol

$(document).ready(function () {
  // Get the initial turn count
  let turns = $(".section-randomizer #turn-number").data("id");
  let startSpinTurns = turns; // Separate counter for Start Spin
  let showResultTurns = turns; // Separate counter for Show Result

  function decrementStartSpinTurns() {
    startSpinTurns--;
    // console.log(`Start Spin turns left: ${startSpinTurns}`);
    if (startSpinTurns <= 0) {
      $("#startSpin").prop("disabled", true); // Disable Start Spin when no turns left
      // console.log("Start Spin disabled.");
    }
  }

  function decrementShowResultTurns() {
    showResultTurns--;
    // console.log(`Show Result turns left: ${showResultTurns}`);
    if (showResultTurns <= 0) {
      $("#showResult").prop("disabled", true); // Disable Show Result when no turns left
      // console.log("Show Result disabled.");
    }
  }

  if (typeof $(document).raffleDrumAnimation === "function") {
    startRaffleAnimation();

    // Handle Start Spin button click
    $("#startSpin").click(function () {
      $("#startSpin").prop("disabled", true);
      if (startSpinTurns > 0) {
        $("#firstDrumHolder").raffleDrumAnimation("spin");
        decrementStartSpinTurns();
        $("#showResult").prop("disabled", false);
      }
    });

    // Handle Show Result button click
    $("#showResult").click(function () {
     
      $("#showResult").prop("disabled", true);
      if (showResultTurns > 0) {

        $("#startSpin").prop("disabled", false);
        $("#firstDrumHolder").raffleDrumAnimation("result");
      }
    });

    // Optional: Handle Toggle Spin
    $("#toggleSpin").click(function () {
      $("#firstDrumHolder").raffleDrumAnimation("toggleSpin");
    });

    // Optional: Handle Stop Spin
    $("#stopSpin").click(function () {
      $("#firstDrumHolder").raffleDrumAnimation("stop");
    });
  } else {
    console.error("raffleDrumAnimation plugin is not available.");
  }

  function startRaffleAnimation() {
    const itemImages = [];
    let imageIds = $(".section-randomizer #participants").data("id");

    $(".drumSideHolder .side img").each(function () {
      const imgSrc = $(this).attr("src");
      const imgIdSrc = $(this).attr("data-id");
      if (imgSrc) {
        itemImages.push(imgSrc);
      }
    });

    $("#firstDrumHolder").raffleDrumAnimation({
      itemImage: itemImages,
      itemRow: 7,
      itemColumn: 5,
      callback: function (data) {
        raffleCallback(data);
      },
    });
  }

  function raffleCallback(data) {
    // console.log("data:", data);
    // return false;
    switch (data.status) {
      case "spinstart":
        // console.log("Drum started spinning.");
        break;

      case "spinstop":
        // console.log("Drum stopped spinning.");
        break;

      case "result":
        if (data.id) {
          // Dynamically update the winner element with the data returned
          // console.log(data.winner);
          // $("#" + data.id + " .ticketResult .item").html(
          //   "<div>" + (data.winner || "my result") + "</div>"
          // );
          showWinner(showResultTurns);
          decrementShowResultTurns();
        } else {
          console.error("Data ID not provided in the result.");
        }
        break;

      case "resultcomplete":
        // console.log("Result display complete.");
        break;

      default:
        console.log("Unhandled status:", data.status);
    }
  }

  function showWinner(showResultTurns) {
    let ajaxUrl = ajax_callback_data.ajax_url;

    const giveaway_form = document.getElementById('giveaway_form');

    let formData = new FormData( giveaway_form );

    //SET AJAX ACTION FROM POST FIELD METHOD
    formData.append("action", "get_winner_details")

    formData.append("turns", showResultTurns)

    jQuery.ajax({
      url: ajaxUrl, // URL to your PHP handler
      xhrFields: {
          withCredentials: true
      },
      contentType: false,
      processData: false,
      type: "POST",
      data: formData, // Send the data object with the action
      success: function (response) {
        
        $(".error-randomizer").addClass('d-none'); 

        const Jresponse = typeof response === "string" ? JSON.parse(response) : response;
        if( Jresponse.status === false ){
          $(".error-randomizer").html(Jresponse.error).removeClass('d-none');
        }else{

          winnerClass = getRankingClass(showResultTurns);
          $("body .ticketResult").show();
            // Append the winner details dynamically to the ticket result section
            $("body #firstDrumHolder .ticketResult .item").append(
              `<div class="winner-details">
                <div class="winner-details__name">${Jresponse.data.name}</div>
            </div>`
            );

            // Append the winner details dynamically to the winner section
              $(".winner-section").append(
                `<div class="winner-details ${winnerClass}">
              <div class="winner-detail">
              <div class="winner-detail__ranking">
                <p class="winner-detail__ranking_val">${Jresponse.data.ranking}</p>
              </div>
              <div class="winner-detail__img">${Jresponse.data.img}</div>
              <div class="winner-detail__name">Winner ${Jresponse.data.ranking}</div>
              </div>
            </div>`
              );
              
          // Disable the "showResult" button
          $("#showResult").prop("disabled", true);
          if( showResultTurns ===  1 ){ $("#startSpin").prop("disabled", true); }

        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error);
      },
    });
    
  }
  function getRankingClass(turns) {
    if (turns === 1 || turns % 3 === 1) {
      return "group-one";
    } else if (turns === 2 || turns % 3 === 2) {
      return "group-two";
    } else if (turns === 3 || turns % 3 === 0) {
      return "group-three";
    }
    return "other-place"; // Default for any unexpected value
  }
});
